module.exports = {"411602001":"陈州街回族街道","411602002":"七一路街道","411602003":"荷花路街道","411602004":"人和街街道","411602005":"小桥街街道","411602006":"城南街道","411602007":"城北街道","411602008":"文昌街道","411602009":"搬口街道","411602010":"金海路街道","411602013":"李埠口街道","411602014":"许湾街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411602.json
// module id = 1797
// module chunks = 0